import { Box, BoxProps } from '@chakra-ui/react';
import sanitizeHtml, { IOptions } from 'sanitize-html';

const defaultOptions: IOptions = {
  allowedTags: ['b', 'i', 'em', 'strong', 'a', 'br', 'p', 'ul', 'li'],
  transformTags: {
    ul: 'ol',
  },
  allowedAttributes: {
    a: ['href'],
  },
};

export interface SanitizeHTMLProps extends BoxProps {
  html?: string;
  options?: IOptions;
}

export const SanitizeHTML = ({
  html = '',
  options,
  ...props
}: SanitizeHTMLProps) => (
  <Box
    {...props}
    dangerouslySetInnerHTML={{
      __html: sanitizeHtml(html, {
        ...defaultOptions,
        ...options,
      }),
    }}
  />
);
